import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.25 6H13.5V2.25H4.5V6H3.75C2.505 6 1.5 7.005 1.5 8.25V12.75H4.5V15.75H13.5V12.75H16.5V8.25C16.5 7.005 15.495 6 14.25 6ZM6 3.75H12V6H6V3.75ZM12 14.25V12.75V11.25H6V14.25H12ZM13.5 11.25V9.75H4.5V11.25H3V8.25C3 7.8375 3.3375 7.5 3.75 7.5H14.25C14.6625 7.5 15 7.8375 15 8.25V11.25H13.5ZM12.75 8.625C12.75 8.21079 13.0858 7.875 13.5 7.875C13.9142 7.875 14.25 8.21079 14.25 8.625C14.25 9.03921 13.9142 9.375 13.5 9.375C13.0858 9.375 12.75 9.03921 12.75 8.625Z",
		fill: "#14803C"
	})
});
export default SvgIconLeft;
